import React from 'react';
import Banner from './Banner';
import AboutMe from './about_me/AboutMe';
import Footer from './Footer';
import Skills from './skills/Skills';
import Projects from './projects/projects_done/DisplayProjects';
//import Hovers from './header/header'
//import DisplayProjects from './componets/projects/Final_projects/DisplayProjects'

export default function Home() {
  return (
    <>
      <Banner />
      <AboutMe />
      <Skills />
      <Projects/>
      <Footer/>
    </>
  );
}
